import Image from 'next/image';
import { Heading, Paragraph } from '@swordhealth/ui-corporate';
import { ACTIONS, BUTTON_TYPES, trackButtonClicked } from '@/utils/track';
import {
  AvatarSubtitle,
  AvatarWrapper,
  BannerCard,
  ContentWrapper,
  StyledContainer,
  StyledSectionHeader,
  StyledTextLink,
  TitlesWrapper,
} from './styles';

const BannerSection = ({ content }) => {
  const {
    sectionHeader: { title, description, titleSize, upperLabel, xAlign },
    bannerCard,
    config,
  } = content;

  return (
    <StyledContainer xAlign="center">
      <StyledSectionHeader
        label={upperLabel}
        title={title}
        description={description}
        titleSize={titleSize ?? '2xl'}
        xAlign={xAlign ?? 'center'}
      />
      <BannerCard $notColored={config?.colored || config?.withGradient}>
        <ContentWrapper>
          <TitlesWrapper>
            <Heading size="lg" weight="bold">
              {bannerCard.title}
            </Heading>
            <Paragraph>{bannerCard.subtitle}</Paragraph>
          </TitlesWrapper>
          <div>
            <StyledTextLink
              arrow="right"
              href={bannerCard.url}
              onClick={() =>
                trackButtonClicked({
                  action: ACTIONS.REDIRECT_TO_DESTINATION,
                  buttonType: BUTTON_TYPES.NAVIGATION,
                  buttonText: bannerCard?.urlText,
                  destination: bannerCard?.url,
                  buttonLocation: 'webinar-banner-section',
                })
              }
              target="_blank"
            >
              {bannerCard.urlText}
            </StyledTextLink>
          </div>
        </ContentWrapper>
        <AvatarWrapper>
          <Image
            id="avatar_image"
            src={bannerCard.avatarImage.data.attributes.url}
            alt={bannerCard.avatarImage.data.attributes.alternativeText ?? ''}
            objectFit="contain"
            width={80}
            height={80}
          />
          <Paragraph size="sm" weight="bold">
            {bannerCard.avatarTitle}
          </Paragraph>
          <AvatarSubtitle size="sm" weight="regular">
            {bannerCard.avatarSubtitle}
          </AvatarSubtitle>
        </AvatarWrapper>
      </BannerCard>
    </StyledContainer>
  );
};

BannerSection.defaultConfig = {
  rounded: false,
  colored: true,
  spaceBottom: true,
  spaceTop: true,
  marginBottom: false,
  withGradient: true,
  gradientColor: true,
  roundedTop: true,
};

export default BannerSection;
